<template>
  <div class="background">
    <div class="sideBySide">
      <div class="letterList">
        <div class="lettreContainer">
          <span class="letter">A</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">C</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">H</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">L</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">P</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">T</span>
          <div class="hiddenTitle"></div>
        </div>
        <div class="lettreContainer">
          <span class="letter">U</span>
          <div class="hiddenTitle"></div>
        </div>
      </div>
      <div class="whiteBackground">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.background {
  position: absolute;
  background-color: rgba(103, 103, 103, 0.08);
  width: 90%;
  height: 85%;
}

.whiteBackground {
  background-color: white;
  width: 75%;
  height: 70%;
  margin-top: 3%;
  margin-bottom: 3%;
}

.letterList {
  width: 25%;
}

.sideBySide {
  display: flex;
}

.letter {
  font-size: 500%;
}
</style>
